// Domain configuration for dual deployment architecture
// Primary brand: cSquare (c²) | Legal entity: cSquare GRC, Inc., a Delaware C corporation (inc. Aug 2026)
// Holding company: JNN Group, Inc. (inc. Apr 2014)
export const DOMAINS = {
  // Marketing site domains
  MARKETING_PRIMARY: "https://csquaregrc.com",
  MARKETING_LEGACY: "https://jnngroup.com",
  MARKETING_LEGACY_2: "https://c2platform.ai",
  
  // c² (cSquare) app domains  
  CSQUARE_PRIMARY: "https://app.csquaregrc.com",
  CSQUARE_LEGACY: "https://app.jnngroup.com",
  CSQUARE_LEGACY_2: "https://app.c2platform.ai",
  CSQUARE_SECONDARY: "https://app.compliancecore.ai",
} as const;

// Helper functions for cross-domain navigation
export const getMarketingUrl = (path: string = "") => {
  return `${DOMAINS.MARKETING_PRIMARY}${path}`;
};

export const getCSquareUrl = (path: string = "") => {
  return `${DOMAINS.CSQUARE_PRIMARY}${path}`;
};

// Alias for backward compatibility
export const getComplianceCoreUrl = getCSquareUrl;

// Environment detection helpers
export const isMarketingSite = () => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return hostname === 'csquaregrc.com' || 
         hostname === 'www.csquaregrc.com' ||
         hostname === 'c2platform.ai' || 
         hostname === 'www.c2platform.ai' ||
         hostname === 'jnngroup.com' || 
         hostname === 'www.jnngroup.com';
};

export const isCSquareSite = () => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return hostname === 'app.csquaregrc.com' || 
         hostname === 'app.c2platform.ai' || 
         hostname === 'app.jnngroup.com' ||
         hostname === 'app.compliancecore.ai';
};

// Alias for backward compatibility
export const isComplianceCoreSite = isCSquareSite;
